<span class="detail-field-label">{{ field.label | translate }}</span>

<!-- Inline editor (only reachable when mode === 'inline' and the row is open) -->
<div class="detail-field-editor" *ngIf="editing; else displayValue">
  <!-- Searchable single-select: filter box + option list. The backdrop lets the
       user leave without picking anything (blur can't close it — clicking an
       option blurs the input first). -->
  <div class="detail-field-lookup" *ngIf="inlineType === 'lookup'; else simpleInput">
    <div class="detail-field-lookup-backdrop" (click)="cancelInlineEdit()"></div>
    <input
      #lookupInput
      class="detail-field-input"
      type="text"
      [(ngModel)]="lookupQuery"
      [attr.placeholder]="'common.search' | translate"
      (keydown.escape)="cancelInlineEdit()"
    />
    <div class="detail-field-lookup-list">
      <button
        type="button"
        class="detail-field-lookup-option detail-field-lookup-option--clear"
        *ngIf="canClear"
        (click)="clearValue()"
      >
        <ui-svg-icon svgIcon="close" size="small"></ui-svg-icon>
        <span>{{ 'detail_fields.clear' | translate }}</span>
      </button>

      <button
        type="button"
        class="detail-field-lookup-option"
        *ngFor="let option of filteredOptions"
        [class.selected]="option.id === field.selectedOptionId"
        (click)="selectOption(option)"
      >
        {{ option.name }}
      </button>
      <span class="detail-field-lookup-empty" *ngIf="!filteredOptions.length">
        {{ 'common.no_results' | translate }}
      </span>
    </div>
  </div>

  <!-- Text and date share one input; only the native type differs. -->
  <ng-template #simpleInput>
    <textarea
      *ngIf="inlineType === 'textarea'; else singleLineInput"
      #textareaInput
      class="detail-field-input detail-field-input--textarea"
      rows="4"
      [(ngModel)]="draft"
      (blur)="onInlineBlur()"
      (keydown.escape)="cancelInlineEdit()"
    ></textarea>

    <ng-template #singleLineInput>
      <input
        #inlineInput
        class="detail-field-input"
        [type]="inlineType === 'date' ? 'date' : 'text'"
        [(ngModel)]="draft"
        (blur)="onInlineBlur()"
        (keydown.enter)="saveInlineEdit()"
        (keydown.escape)="cancelInlineEdit()"
      />
    </ng-template>
  </ng-template>
</div>

<ng-template #displayValue>
  <!-- Host-provided markup (badges, links) wins over the plain value. -->
  <span class="detail-field-value" *ngIf="slotTemplate; else plainValue">
    <ng-container *ngTemplateOutlet="slotTemplate; context: { $implicit: field }"></ng-container>
  </span>

  <ng-template #plainValue>
    <ui-copyable
      *ngIf="copyValue !== null; else noCopy"
      class="detail-field-value"
      [class.inline-editable]="mode === 'inline'"
      [value]="copyValue"
      [label]="field.label | translate"
      (click)="startInlineEdit()"
    >
      {{ field.value }}
    </ui-copyable>

    <ng-template #noCopy>
      <span
        class="detail-field-value"
        [class.inline-editable]="mode === 'inline'"
        [class.is-empty]="isEmpty"
        (click)="startInlineEdit()"
      >
        {{ isEmpty ? emptyPlaceholder : field.value }}
      </span>
    </ng-template>
  </ng-template>
</ng-template>

<!-- Modal rows keep the pencil that opened their dialog before WB-7463. -->
<button
  type="button"
  class="detail-field-edit-button"
  *ngIf="mode === 'modal'"
  [attr.data-testid]="field.key ? 'detail-field-' + field.key + '-edit' : null"
  (click)="onEditClick()"
  [attr.aria-label]="'common.edit' | translate"
>
  <ui-svg-icon svgIcon="edit_icon" size="small"></ui-svg-icon>
</button>
